export default "__VITE_ASSET__CmTpnw1r__"